import React, {ChangeEvent} from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import {MemberRegion} from "../regions/MemberRegions";
import {Member} from "./Members";

export default function AddMember(params: {
    show: boolean,
    member: Member, regions: MemberRegion[],
    close: (member?: Member) => void
}) {
    const {showMessage} = useAlert()
    const [member, setMember] = React.useState(params.member)
    const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setMember({...member, [event.target.name]: event.target.value})
    }

    const saveMember = () => {
        Utils.toggleSpinner('show')
        AppApi.saveMember(member)
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    params.close({...member, member_id: res.data['member_id']})
                } else {
                    showMessage({message: res.data.message, type: 'error'})
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error saving member, please retry', type: 'error'})
            })
    }

    React.useEffect(() => {
        setMember(params.member)
    }, [params.member])

    return (
        <div className={`modal_container ${params.show ? 'show' : ''}`.trim()}>
            <div className="modal_body">
                <h6 className="mb-4">{params.member.member_id === 0 ? 'Add Member' : 'Edit Member'}</h6>

                <form method="post">
                    <div className="mb-3">
                        <label htmlFor="hotel_name" className="form-label">Hotel Name</label>
                        <input type="text" className="form-control" id="hotel_name" name="hotel_name"
                               value={member.hotel_name} onChange={handleChange} required/>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="regionId" className="form-label">Hotel Region</label>
                        <select className="form-select" id="regionId" name="regionId" required
                                value={member.regionId} onChange={handleChange}>
                            <option value={''} defaultChecked={params.member.regionId === ''}>Select Region</option>
                            {
                                params.regions.map(region =>
                                    <option value={region.regionId} defaultChecked={params.member.regionId === region.regionId}>
                                        {region.regionName}
                                    </option>)
                            }
                        </select>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="first_name" className="form-label">Owner's First Name</label>
                        <input type="text" className="form-control" id="first_name" name="first_name"
                               value={member.first_name} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="last_name" className="form-label">Owner's Last Name</label>
                        <input type="text" className="form-control" id="last_name" name="last_name"
                               value={member.last_name} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="owner_number" className="form-label">Owner's Contact Number</label>
                        <input type="text" className="form-control" id="owner_number" name="owner_number"
                               value={member.owner_number} onChange={handleChange} required/>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Hotel Email</label>
                        <input type="email" className="form-control" id="email" name="email"
                               value={member.email} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="contact_number1" className="form-label">Hotel Contact Number 1</label>
                        <input type="text" className="form-control" id="contact_number1" name="contact_number1"
                               value={member.contact_number1} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="contact_number2" className="form-label">Hotel Contact Number 2</label>
                        <input type="text" className="form-control" id="contact_number2" name="contact_number2"
                               value={member.contact_number2} onChange={handleChange}/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="rooms" className="form-label">Number of Hotel Rooms</label>
                        <input type="text" className="form-control" id="number_of_rooms" name="number_of_rooms"
                               value={member.number_of_rooms} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="staffs" className="form-label">Number of Hotel Staffs</label>
                        <input type="text" className="form-control" id="number_of_staffs" name="number_of_staffs"
                               value={member.number_of_staffs} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="registration_date" className="form-label">Registration Date</label>
                        <input type="date" className="form-control" id="registration_date" name="registration_date"
                               value={member.registration_date} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="expiry_date" className="form-label">Expiry Date</label>
                        <input type="date" className="form-control" id="expiry_date" name="expiry_date"
                               value={member.expiry_date} onChange={handleChange} required/>
                    </div>
                </form>

                <div className={'form_buttons'}>
                    <div className={'row m-0'}>
                        <div className={'col-6 ps-0 pe-1'}>
                            <button type="button" className="btn btn-secondary" onClick={() => params.close()}>Close Window
                            </button>
                        </div>
                        <div className={'col-6 ps-1 pe-0'}>
                            <button type="button" className="btn btn-primary" onClick={saveMember}>Add Member</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}